import Quill from "quill";

Quill.register(Quill.import('attributors/style/direction'), true);
Quill.register(Quill.import('attributors/style/align'), true);


const Block = Quill.import('blots/block');
Block.tagName = 'div';
Block.className = 'texto';

Quill.register(Block, true);


const Bold = Quill.import('formats/bold');
Bold.tagName = 'b';
Quill.register(Bold, true);





// WEBPACK FOOTER //
// ./src/quilljs.js